import React from "react";
import "./Contact.css";
import line from "../Assets/catalog-line-img.svg";
import { FaArrowRightLong } from "react-icons/fa6";
import { SiWhatsapp } from "react-icons/si";
import { IoLocationOutline } from "react-icons/io5";
import { CiVideoOn } from "react-icons/ci";
import { MdEmail } from "react-icons/md";
import { FaPhoneAlt } from "react-icons/fa";
import { SlSocialInstagram } from "react-icons/sl";

const Contact = () => {
  return (
    <div className="Contact-page">
      <div className="">
        <div className="data-section">
          <div className="contact_heading">
            <h2 className="cata-heading font-bold text-xl">Connect with Us</h2>
            <p className="srj"> <strong className="uppercase">Shree Rupmani Jewellers</strong></p>
          </div>
          <div className="para">
            <p className="para-text">
              <strong>Shop No. 21</strong>, Groundfloor , Supermall , Near Lal
              Bungalow , C.G. Road Ahmedabad-380006
            </p>
          </div>
          <div className="para">
          <MdEmail /> 
            <strong>- Shreerupmanijewellers@gmail.com</strong>
          </div>
          <div className="para">
          <FaPhoneAlt />
            <strong>- 9649835858</strong>
          </div>
          <img src={line} alt="line" />
        </div>
        <div className="data-section">
          <p className="srj"> <strong>SHREE RUKMANI JEWELLERS</strong></p>
          <p className="para-text">
              <strong>ADD :-</strong>MAKOBA COMPLEX, MAIN HOSPITAL ROAD, MANPURA COLONY JALORE -343001 
            </p>
            <div className="text-center">
              <div className="para">
              <FaPhoneAlt/>
              <strong>- 9667757225</strong>
              </div>
            <img src={line} alt="line" />
          </div>
          </div>
        <div className="data-section">
          <p className="srj"> <strong>SHREE PHOOLMALI JEWELLERS</strong></p>
          <p className="para-text">
              <strong>ADD :-</strong>LACHUBA COMPLEX, OLD BUS STAND, SAYALA -343022 
            </p>
            <div className="text-center">
              <div className="para">
              <FaPhoneAlt/>
              <strong>- 9983212112</strong>
              </div>
            <img src={line} alt="line" />
          </div>
          <div className="para flex flex-col">
            <strong>OWNER</strong>
            <div className="para">
              <p className="uppercase">chagan mali</p>
              <strong>- 9414534883</strong>
              </div>
            <div className="para">
              <p className="uppercase">dhanraj mali</p>
              <strong>- 9414534911</strong>
              </div>
          </div>
          </div>
        <div className="contact-container">
          <div className="contact-card-container">
            <div className="card">
              <div>
                <h5 className="">Connect On</h5>
                <h3>
                  <strong>WhatsApp</strong>
                </h3>
                <button className="btn">
                  <div>
                    <a className="link" href="https://wa.me/919649835858" target="blank">Connect</a>
                  </div>
                  <FaArrowRightLong />
                </button>
              </div>
              <div className="contact-img">
                <SiWhatsapp />
              </div>
            </div>
            <div className="card">
              <div>
                <h5 className="">Follow On</h5>
                <h3>
                  <strong>Instagram</strong>
                </h3>
                <button className="btn">
                  <div>
                    <a className="link" href="https://www.instagram.com/shreerupmaniofficial/profilecard/?igsh=MTJjOTI5bzB1bDFxZA==" target="_blank" >Connect</a>
                  </div>
                  <FaArrowRightLong />
                </button>
              </div>
              <div className="contact-img">
              <SlSocialInstagram />
              </div>
            </div>
            {/* <div className="card">
              <div>
                <h5 className="">Book an</h5>
                <h3>
                  <strong>Appointment</strong>
                </h3>
                <button className="btn">
                 <a className="whatsapp_link" href="https://wa.me/919649835858" target="blank"> Book</a>
                  <FaArrowRightLong />
                </button>
              </div>
              <div className="contact-img">
                <IoLocationOutline />
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
